import { BUSINESS } from "../../data/content";

export const TopBar = () => {
  return (
    <div data-testid="top-bar" className="bg-fc-navy2 text-white">
      <div className="mx-auto w-[92%] max-w-[1280px] flex items-center justify-between py-2.5 text-[13px]">
        <span className="font-semibold tracking-wide">{BUSINESS.name}</span>
        <a data-testid="top-bar-call" href={BUSINESS.phoneHref} className="font-bold hover:text-fc-orange transition-colors">
          Call {BUSINESS.phone}
        </a>
      </div>
    </div>
  );
};
